module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dnRzc"))).then(() => parcelRequire('1iHdE'));